export default __webpack_public_path__ + "static/media/product-image-card-2.819cdadb.jpg";